// Origen de la magia
// https://www.fabiofranchino.com/blog/vue-import-components-dynamically/
// https://github.com/fabiofranchino/vue-import-components-dynamically/

import Vue from 'vue'

const requireComponent = require.context(
  './customElements', // process.env.VUE_APP_PATH_CUSTOM_COMPONENTS,
  false, // Do not look in subdirectories
  /[\w-]+\.vue$/
)
// console.log(process.env.VUE_APP_PATH_CUSTOM_COMPONENTS)
const list = []

requireComponent.keys().forEach((fileName) => {
  const componentConfig = requireComponent(fileName)
  const componentName = fileName
    .replace(/^\.\//, '')
    .replace(/\.\w+$/, '')
    .split('-')
    .map((kebab) => kebab.charAt(0).toUpperCase() + kebab.slice(1))
    .join('')

  list.push({
    id: componentName.toLowerCase(),
    label: componentName.charAt(0).toUpperCase() + componentName.slice(1)
  })

  Vue.component(componentName, componentConfig.default || componentConfig)
})

export default list
